var _affirm_config = {
		public_api_key: "ZX7YFPMCLT27M1SS",
		script: "https://cdn1.affirm.com/js/v2/affirm.js",
		locale: "en_US",
		country_code: "USA",
	};

(function(m,g,n,d,a,e,h,c){var b=m[n]||{},k=document.createElement(e),p=document.getElementsByTagName(e)[0],l=function(a,b,c){return function(){a[b]._.push([c,arguments])}};b[d]=l(b,d,"set");var f=b[d];b[a]={};b[a]._=[];f._=[];b._=[];b[a][h]=l(b,a,h);b[c]=function(){b._.push([h,arguments])};a=0;for(c="set add save post open empty reset on off trigger ready setProduct".split(" ");a<c.length;a++)f[c[a]]=l(b,d,c[a]);a=0;for(c=["get","token","url","items"];a<c.length;a++)f[c[a]]=function(){};k.async=
  !0;k.src=g[e];p.parentNode.insertBefore(k,p);delete g[e];f(g);m[n]=b})(window,_affirm_config,"affirm","checkout","ui","script","ready","jsReady");


function getCurrentPrice() {
    const state = window.NolahPDPState;
    return state && typeof state.getPrice === "function" ? state.getPrice() : null;
}

function formatPrice(cents) {
    return `$${(cents / 100).toFixed(2)}`;
}

function attachAffirmClick(el, price) {
    if (!el) return;
    el.style.cursor = "pointer";
    el.onclick = function (e) {
        e.preventDefault();
        e.stopPropagation();
        openAffirmModal(price);
    };
}

function openAffirmModal(price) {
    if (window.affirm?.ui?.openModal) {
        affirm.ui.openModal({ amount: price });
    }
}

function updateCustomSpan() {
    const baseEl = document.querySelector(".affirm-as-low-as.AffirmEstimate--loaded span.affirm-ala-price");
    if (!baseEl) return;

    const priceText = baseEl.textContent.trim();
    if (!priceText) return;

    document.querySelectorAll(".affirm-custom-text")
        .forEach(span => (span.textContent = priceText));
}

function renderAffirm() {
    const affirmEl = document.querySelector(".affirm-as-low-as");
    if (!affirmEl) return;

    const price = getCurrentPrice();
    if (!price) return;

    affirmEl.setAttribute("data-amount", price);

    if (window.affirm?.ui?.refresh) {
        affirm.ui.refresh();
    }

    attachAffirmClick(affirmEl, price);

    document.querySelectorAll(".custom-affirm-container")
        .forEach(el => attachAffirmClick(el, price));

    updateCustomSpan();
}

function observeAffirmPrice() {
    const target = document.querySelector(".affirm-as-low-as.AffirmEstimate--loaded");
    if (!target) return;

    const observer = new MutationObserver(updateCustomSpan);
    observer.observe(target, { childList: true, subtree: true, characterData: true });
}

document.addEventListener("DOMContentLoaded", () => {
    renderAffirm();
    observeAffirmPrice();

    setTimeout(() => {
        renderAffirm();
        updateCustomSpan();
    }, 300);
});

document.addEventListener("state:option-changed", () => {
    renderAffirm();
    setTimeout(updateCustomSpan, 200);
});